import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM orange.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Orange.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function OrangeATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Orange Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Orange Cream Biscuits — zesty orange-flavored cream biscuits in ATC format. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="ATC Orange Cream Biscuit, BearBitz ATC Orange"
        />
        <link rel="canonical" href="https://www.www.bearbitz.in/atc/orange" />
        <meta
          property="og:title"
          content="ATC Orange Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Orange cream biscuit in ATC format with export-ready packaging and premium flavor."
        />
      </Helmet>

      <ProductTemplate
        productTitle="ORANGE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#EF5608"
        sectionBgColor="#FFDAC8"
        productBgcolor="#FF9D6B"
        tableheadBgcolor="#EF5608"
        tableBgcolor="#FFF1EA"
        footerBgcolor="#EF5608"
      />
    </>
  );
}
